import { createFileRoute } from '@tanstack/react-router';
import { TrunksPage } from '../../features/settings/components/trunks-page.js';

export const Route = createFileRoute('/admin/trunks')({ component: TrunksPage });
